export default __webpack_public_path__ + "static/media/role.463b4920.png";